export { default as ITeroOrderPayment } from './ITeroOrderPayment';
export * as Styled from './ITeroOrderPayment.styles';
export * from './ITeroOrderPayment.types';
